import {Grid, MenuItem, Select} from '@material-ui/core';
import {observer} from 'mobx-react-lite';
import dynamic from 'next/dynamic';
import {useEffect} from 'react';

const Plot = dynamic(import('react-plotly.js'), {ssr: false});

export const WidgetAnalyticsPanel = observer(({data}: any) => {
    const sources = Array.from(new Set(data.map((f: any) => f.v.source)));
    let map = new Map();
    let SourceList: any = [];
    sources.forEach((wl) => {
        SourceList.push({
            sourceName: wl + '_clicked',
            value: {},
        });
        SourceList.push({
            sourceName: wl + '_landed',
            value: {},
        });
    });
    data.forEach((dataElement: any) => {
        let key = [dataElement.v.client, dataElement.v.state];
        if (!map.has(key)) {
            map.set(key, true);
            const srcSearchName = dataElement.v.source + '_' + (dataElement.v.state == 'landed' ? 'landed' : 'clicked');
            const currentDate = dataElement.p;
            SourceList.forEach((wl: any, ind: number) => {
                if (wl.sourceName == srcSearchName) {
                    let cnt = wl.value[currentDate] === undefined ? 0 : wl.value[currentDate];
                    wl.value[currentDate] = cnt + 1;
                }
            });
        }
    });
    return (
        <Grid container spacing={3}>
            <Grid item xs={12}></Grid>
            <div style={{width: '100%'}}>
                <Plot
                    style={{width: '100%', height: '500px'}}
                    data={SourceList.map((a: any) => {
                        const keys = Object.keys(a.value);
                        let countList: any = [];
                        keys.forEach((key) => countList.push(a.value[key]));
                        return {
                            type: 'scatter',
                            name: a.sourceName,
                            x: keys,
                            y: countList,
                            mode: 'lines+markers',
                        };
                    })}
                    layout={{
                        title: {text: 'Digital Lead Report'},
                        autosize: true,
                        barmode: 'stack',
                    }}
                />
            </div>
            <Grid item xs={12}></Grid>
        </Grid>
    );
});
